import axiosInstance from '../axios/axiosInstance';

export async function logout() {
  try {
    await axiosInstance.get(`/auth/logout`);
  } catch (error) {
    console.error('Error during logout:', error);
  }
}
